(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SchemaTable", [], factory);
	else if(typeof exports === 'object')
		exports["SchemaTable"] = factory();
	else
		root["SchemaTable"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition